import axios from 'axios';
import config from '../config-api.json';
import {
  GetPathNetworkRecommendType,
  GetPatentParamType,
  GetPatentType,
  GetRecommendedWordParamType,
  GetRecommendedWordType,
} from './type';
import {
  GetPathNetworkRecommendParamType2,
  GetPathNetworkRecommendType2,
} from './recommendType';

function noop() {}

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
} else {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}

export interface responseType {
  message: string;
  payload: any;
  status_code: number;
}

export interface payloadType {}

export async function apiGetPathNetworkRecommend(info: {
  query: string | string[];
  date_unit: string;
}) {
  const response = await axios.get<GetPathNetworkRecommendType>(
    `${apiInfo.api_url}/path_network_recommend/`,
    {
      params: {
        total_count: 20,
        session: localStorage.getItem('aivory_session_id') || 'test_session',
        query: info.query,
        type: 1,
        date_unit: info.date_unit,
        path_length: 3,
        by_index: 0,
      },
    }
  );

  return response.data;
}

export async function apiGetPatent(info: GetPatentParamType) {
  const response = await axios.get<GetPatentType>(
    `${apiInfo.api_url}/knowledge_graph/patent/`,
    {
      params: {
        query: info.query,
      },
    }
  );

  return response.data;
}

export async function apiGetRecommendedWord(info: GetRecommendedWordParamType) {
  const response = await axios.get<GetRecommendedWordType>(
    `${apiInfo.api_url}/recommended_word/`,
    {
      params: {
        word: info.word,
      },
    }
  );

  return response.data;
}

export async function apiGetPathNetworkRecommend2(
  info: GetPathNetworkRecommendParamType2
) {
  const response = await axios.get<GetPathNetworkRecommendType2>(
    `${apiInfo.api_url}/path_network_recommend/`,
    {
      params: {
        session: info.session,
        date_unit: info.date_unit,
        total_count: info.total_count,
        query: info.query,
      },
    }
  );

  return response.data;
}
